import { Controller } from "@hotwired/stimulus"

// Generic controller for selecting items and updating a hidden field
// Usage:
//   Container: data-controller="form-select" data-form-select-target-value="hidden_field_id"
//   Items: data-action="click->form-select#select" data-form-select-value-param="value"
export default class extends Controller {
  static values = { target: String }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    const value = button.dataset.formSelectValueParam

    // Update hidden field
    const targetField = document.getElementById(this.targetValue)
    if (targetField) {
      targetField.value = value
      // Dispatch change event so other controllers can react
      targetField.dispatchEvent(new Event("change", { bubbles: true }))
    }

    // Update visual state - remove selected from siblings
    this.element.querySelectorAll("button, a").forEach((el) => {
      el.classList.remove("border-black", "bg-gray-50", "bg-black", "text-white")
      el.classList.add("border-gray-200", "bg-white", "text-black")
    })

    // Add selected to clicked element - handle both card and slot styles
    button.classList.remove("border-gray-200", "border-gray-300", "bg-white", "text-black")

    // Check if it's a time slot (smaller) or staff card (larger)
    if (button.classList.contains("p-3")) {
      // Time slot style - black background
      button.classList.add("border-black", "bg-black", "text-white")
    } else {
      // Staff card style - gray background
      button.classList.add("border-black", "bg-gray-50")
    }

    // Dispatch custom event for other controllers to react
    this.dispatch("selected", { detail: { value } })
  }
}
